import axios from 'axios';
import {
  action,
  configure,
  decorate,
  observable,
  reaction,
  runInAction,
  toJS,
} from 'mobx';
import {
  API_DASHBOARD_GET_AUCTIONS_ENDPOINT,
  DEV_API_URL,
} from '../shared/constants';
import { getSessionToken } from './../stores/utils';
configure({ enforceActions: 'always' });

class DashboardStore {
  constructor() {
    this.initialize();
  }

  setProperty = (key, val) => {
    this[key] = val;
  };

  getProperty = (key) => {
    return this[key];
  };

  initializeAuctionMetric = () => {
    this.auctionMetric = {
      auction: null,
      auctionID: null,
      dashboardComponent: null,
      endTime: null,
      laneCount: 0,
      laneCount: 0,
      laneMetricList: [],
      productCount: 0,
      productNonStatusedCount: 0,
      productStatusedCount: 0,
      productTotalCount: 0,
      proxyBidCount: 0,
      registeredMembers: 0,
      registeredUsers: 0,
      startTime: null,
      totalItems: 0,
      totalItemsError: 0,
      totalItemsPending: 0,
      totalItemsUploaded: 0,
      uniqueRegisteredUsers: 0,
    };
  };

  initializeLaneMetric = () => {
    this.laneMetric = {
      laneID: null,
      laneName: null,
      laneTotalItems: 0,
      laneTotalItemsError: 0,
      laneTotalItemsPending: 0,
      laneTotalItemsUploaded: 0,
      laneTotalUnits: 0,
      productNonStatusedCount: 0,
      productStatusedCount: 0,
      productTotalCount: 0,
    };
  };

  initialize = () => {
    this.dashboardCardView = new Map();
    this.dashboardCardViewName = new Map();
    this.setProperty('emitTimestamp', null);
    this.setProperty('isLoading', false);
    this.initializeLaneMetric();
    this.initializeAuctionMetric();
    this.initializeDashboard();
  };

  initializeDashboard = () => {
    //this.setProperty('dashboardCardView', new Map()),
    this.setProperty('auctionMetricList', []);
    this.setProperty('connecting', false);
    // this.setProperty('connected', false);
    this.setProperty('onDashboardScreen', false);
  };

  setDashboardCardView = (auctionID, viewName) => {
    this.dashboardCardViewName.set(auctionID, viewName);
    sessionStorage.setItem(
      'dashboardCardViewName',
      JSON.stringify(this.dashboardCardViewName),
    );
  };

  loadDashboardMetricsFromAPI = async (auctionStateID) => {
    if (!auctionStateID) {
      return;
    }
    this.setProperty('isLoading', true);
    const sessionToken = getSessionToken();
    const params = JSON.stringify({
      auctionStateID: auctionStateID,
      sessionToken: sessionToken,
    });
    const dashboardReportURL =
      DEV_API_URL + API_DASHBOARD_GET_AUCTIONS_ENDPOINT;
    // console.log('dashboardRequest', { dashboardReportURL, params });
    axios
      .post(dashboardReportURL, params, {
        headers: {
          'content-type': 'application/json',
        },
      })
      .then((dashBoardReportResponse) => {
        // console.log(
        //   'dashboardresponse',
        //   JSON.stringify(dashBoardReportResponse),
        // );
        runInAction(() => {
          console.log('loadDashboardMetricsFromAPI');
          this.setDashboardMetrics(dashBoardReportResponse.data);
        });
      });
  };

  setDashboardMetrics = (data) => {
    this.auctionMetricList = [];

    const noAuctionData = !this.auctionMetricList.length;
    if (noAuctionData && data.auctions != null && data.auctions.length > 0) {
      data.auctions.forEach((auct) => {
        let newAuctionlist = this.auctionMetric;
        newAuctionlist.auctionID = auct.auctionID;
        newAuctionlist.auction = auct.auction;
        newAuctionlist.startTime = auct.auctionStartTime;
        newAuctionlist.endTime = auct.auctionEndTime;
        newAuctionlist.totalItems = auct.mediaTotalCount;
        newAuctionlist.totalItemsUploaded = auct.mediaSuccessCount;
        newAuctionlist.totalItemsPending = auct.mediaPendingCount;
        newAuctionlist.totalItemsError = auct.mediaErrorCount;
        newAuctionlist.proxyBidCount = auct.proxyBidCount;
        newAuctionlist.registeredMembers = auct.registeredUserCount;
        newAuctionlist.registeredUsers = auct.memberRegistrationCount;
        newAuctionlist.uniqueRegisteredUsers =
          auct.memberRegistrationUniqueCount;
        newAuctionlist.productCount = auct.productCount;
        newAuctionlist.laneCount = auct.laneCount;
        newAuctionlist.productNonStatusedCount = auct.productNonStatusedCount;
        newAuctionlist.productStatusedCount = auct.productStatusedCount;
        newAuctionlist.productTotalCount = auct.productTotalCount;
        // newAuctionlist.dashboardComponent = this.dashboardCardView.get(auct.auctionID);
        newAuctionlist.laneMetricList = [];
        let index = 0;
        auct.laneMetrics.forEach((laneitem) => {
          let newlaneMetric = this.laneMetric;
          newlaneMetric.laneID = laneitem.laneID;
          newlaneMetric.laneName = laneitem.lane;
          newlaneMetric.laneTotalItems = laneitem.mediaTotalCount;
          newlaneMetric.laneTotalItemsUploaded = laneitem.mediaSuccessCount;
          newlaneMetric.laneTotalItemsPending = laneitem.mediaPendingCount;
          newlaneMetric.laneTotalItemsError = laneitem.mediaErrorCount;
          newlaneMetric.laneTotalUnits = laneitem.unitTotalCount;
          newlaneMetric.productNonStatusedCount =
            laneitem.productNonStatusedCount;
          newlaneMetric.productStatusedCount = laneitem.productStatusedCount;
          newlaneMetric.productTotalCount = laneitem.productTotalCount;

          newAuctionlist.laneMetricList.push(newlaneMetric);
          this.initializeLaneMetric();
        });

        this.auctionMetricList.push(newAuctionlist);
      });
      this.setProperty('auctionMetricList', this.auctionMetricList);
    }

    this.setProperty('isLoading', false);
  };
}

decorate(DashboardStore, {
  auctionMetricList: observable,
  connected: observable,
  connecting: observable,
  dashboardCardView: observable,
  dashboardCardViewName: observable,
  initialize: action,
  initializeDashboard: action,
  isLoading: observable,
  onDashboardScreen: observable,
  setDashboardCardView: action,
  setDashboardMetrics: action,
  setProperty: action,
  emitTimestamp: observable,
});
export default DashboardStore;
